import { useState } from 'react';
import React from 'react';
import Snowfall from 'react-snowfall';
import Link from 'next/link';

import { isChristmasPeriod } from '@/utils/isChristmasPeriod';
import useWindowSize from '@/hooks/utils/useWindowSize';

import Icon from '@/components/base/Icon';
import Iconosquare from '@/components/icons/Iconosquare';
import IconosquareChristmas from '@/components/icons/IconosquareChristmas';
import { TransitionWrapper } from '@/components/layouts/LayoutPlatform/components/Menu/components/TransitionWrapper';

const DESKTOP_BREAKPOINT = 768;

export function MenuHeader({ isMenuOpen, toggleStickyMenu }) {
    const { width: windowWidth } = useWindowSize();
    const [isHoveringLogo, setIsHoveringLogo] = useState(false);

    const isDesktop = windowWidth >= DESKTOP_BREAKPOINT;
    const showChristmas = isChristmasPeriod();
    const showSnowfall = isDesktop && showChristmas && isHoveringLogo;

    return (
        <div className="mb-10 flex items-center justify-between gap-2 px-3 pt-3">
            <div className="flex items-center gap-[9px]">
                <Link
                    href="/"
                    className="inline-block leading-none"
                    data-testid="link-home-page"
                    onMouseEnter={() => setIsHoveringLogo(true)}
                    onMouseLeave={() => setIsHoveringLogo(false)}>
                    {showChristmas ? (
                        <IconosquareChristmas />
                    ) : (
                        <Iconosquare size={24} className="text-icoBlue" />
                    )}

                    {showSnowfall && (
                        <Snowfall
                            snowflakeCount={400}
                            color="#fff"
                            style={{
                                position: 'fixed',
                                width: 'calc(100vw - 200px)',
                                height: '100vh',
                                top: 0,
                                left: '200px'
                            }}
                        />
                    )}
                </Link>
                <TransitionWrapper isOpen={isMenuOpen}>iconosquare</TransitionWrapper>
            </div>

            <button
                onClick={toggleStickyMenu}
                className={isMenuOpen ? 'flex' : 'hidden'}
                data-testid="close-menu-button">
                <Icon
                    icon="sidebar"
                    className="text-icoGray-500 transition-all duration-300 hover:text-icoBlue dark:text-icoDarkMode-wolf"
                />
            </button>
        </div>
    );
}
